<template>
  <div>
    <v-row no-gutters align="center">
      <v-col cols="6" class="pt-8">
        <modal-cadu :close="close" :width="1131.52" v-model="show">
          <div slot="all" class="pt-12 pb-4 px-10">
            <div slot="header">
              <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995d;">
                {{ nomeAcao }} COLABORADOR
              </div>
            </div>

            <div slot="body" v-if="!loadingComponent" class="body-line">
              <ValidationObserver ref="observer">
                <v-row align="center">
                  <v-col cols="6">
                    <validation-provider name="area" mode="eager" rules="required" v-slot="{ errors }">
                      <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Área"
                          v-model="nomeArea"
                          :items="listaAreas"
                          :disabled="!isEdit || isNew || nomeAcaoArea === 'ADICIONar'"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @index="(index) => selectArea(index)"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col class="pr-0" cols="5">
                    <validation-provider
                        name="emailArea"
                        mode="eager"
                        rules="required|email|max:100"
                        v-slot="{ errors }"
                    >
                      <input-cadu
                          :errorMessage="errors[0]"
                          title="E-mail da Área"
                          emailMask
                          :value="emailArea"
                          @input="inputEmailArea"
                          :onlyUpperCase="false"
                          :disabled="true"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col class="pl-3 pt-8" cols="1" v-if="isEdit || isNew">
                    <icon v-if="emailCheck === 2" name="check" :size="12" class="primary1--text" />
                    <span v-else-if="emailCheck === 1" class="warningUtil2--text" style="font-size: 14px;"> ! </span>
                    <icon v-else-if="emailCheck === 0" name="x" :size="12" class="error--text" />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="4">
                    <validation-provider name="nomeColaborador" mode="eager" rules="required" v-slot="{ errors }">
                      <input-cadu
                          :errorMessage="errors[0]"
                          title="Nome do Colaborador"
                          placeholder=""
                          onlyText
                          v-model="nomeColaborador"
                          :disabled="boolComputed"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                      />
                    </validation-provider>
                  </v-col>

                  <v-col cols="6">
                    <validation-provider
                        name="emailColaborador"
                        mode="eager"
                        rules="required|email"
                        v-slot="{ errors }"
                    >
                      <input-cadu
                          :errorMessage="errors[0]"
                          title="E-mail"
                          v-model="emailColaborador"
                          :disabled="boolComputed"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          :onlylowerCase="true"
                          emailMask
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="5">
                    <validation-provider name="cargo" mode="eager" rules="required" v-slot="{ errors }">
                      <autocomplete-cadu
                          :errorMessage="errors[0]"
                          title="Cargo"
                          v-model="cargoColaborador"
                          :items="listaCargos"
                          :disabled="boolComputed"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                          @index="(index) => selectCargo(index)"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </div>

            <div slot="footer">
              <v-row align="start" justify="start" class="pt-2">
                <v-col cols="auto" v-if="isEdit">
                  <button-cadu outline @click="verifyCancelar"> CANCELAR </button-cadu>
                </v-col>

                <v-col cols="auto" v-if="!isEdit && isNew">
                  <button-cadu @click="show = false" outline> VOLTAR </button-cadu>
                </v-col>

                <v-row align="end" justify="end" class="mr-2">
                  <v-col cols="auto" v-if="isNew">
                    <button-cadu
                        :backColor="$vuetify.theme.themes.light.primary2"
                        block
                        class="px-4"
                        @click="saveChanges(false)"
                    >
                      SALVAR E ADICIONAR OUTRO
                    </button-cadu>
                  </v-col>

                  <v-col @click="saveChanges(true)" cols="auto" v-if="isNew || isEdit">
                    <button-cadu> SALVAR </button-cadu>
                  </v-col>
                </v-row>
              </v-row>

              <v-row justify="end" v-if="!isEdit && !isNew">
                <v-col cols="auto">
                  <button-cadu @click="show = false"> VOLTAR </button-cadu>
                </v-col>
              </v-row>
            </div>

            <component-loading :value="loadingComponent" />
          </div>
        </modal-cadu>
      </v-col>
    </v-row>

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="resetEdicao" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import jwtDecode from 'jwt-decode'

import Cargo from '@/services/Cargo'
import { cloneDeep, isEqual } from 'lodash'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    nomeAcao: {
      type: String,
      required: true,
      default: 'VISUALIZAR'
    },
    isNew: {
      type: Boolean,
      default: false
    },
    colaborador: {
      type: Object,
      required: false
    },
    area: {
      type: String,
      required: false,
      default: ''
    },
    email: {
      type: String,
      required: false,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    emailCheck: {
      type: Number,
      default: -1
    },
    listaAreas: {
      type: Array,
      default: () => []
    },
    dominiosAreas: {
      type: Array,
      default: () => []
    },
    nomeAcaoArea: {
      type: String,
      default: 'VISUALIZAR'
    }
  },
  data() {
    return {
      close: true,
      show: this.value,
      nomeArea: '',
      emailArea: '',
      nomeColaborador: '',
      emailColaborador: '',
      cargoColaborador: '',
      listaCargos: [],
      dominiosCargos: [],
      role: '',
      idCargoProp: null,
      idCargo: null,
      idTipoArea: '',
      loadingComponent: false,
      cloneColaborador: {},
      showModalCancelar: false,
      idColaborador: this.colaborador ? this.colaborador.id : null,
      edit: JSON.parse(localStorage.getItem('optionEdit'))
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    const decoded = jwtDecode(this.tokenBearer)

    this.role = decoded.role
  },
  methods: {
    inputEmailArea(input) {
      this.emailArea = input
    },
    async verifyCancelar() {
      const newObj = {
        id: this.idColaborador,
        nome: this.nomeColaborador,
        email: { endereco: this.emailColaborador },
        cargo: { nome: this.cargoColaborador, id: this.idTipoArea === null ? this.idCargoProp : this.idTipoArea }
      }

      if (!isEqual(this.cloneColaborador, newObj)) this.showModalCancelar = true
    },
    async resetEdicao() {
      this.showModalCancelar = false
      this.loadingComponent = true

      try {
        await this.getCargos()
      } catch (error) {
        console.error('Erro ao recarregar cargos durante reset:', error)
        this.loadingComponent = false
        return
      }

      this.idColaborador = this.cloneColaborador.id
      this.nomeColaborador = this.cloneColaborador.nome
      this.emailColaborador = this.cloneColaborador.email.endereco
      this.cargoColaborador = this.cloneColaborador.cargo.nome

      if (this.idTipoArea) this.idTipoArea = this.cloneColaborador.cargo.id
      else this.idCargoProp = this.cloneColaborador.cargo.id

      this.idCargoProp = this.cloneColaborador.cargo.id
      this.loadingComponent = false
    },
    async start(colaborador) {
      this.loadingComponent = true
      this.dominiosCargos = []
      this.listaCargos = []

      try {
        await this.getCargos()
      } catch (error) {
        console.error('Erro ao carregar cargos na inicialização:', error)
        this.loadingComponent = false
        return
      }

      // NOVO: Verifica se a prop colaborador é a resposta completa da API e extrai o colaborador real
      const colaboradorReal = (colaborador && colaborador.conteudo && colaborador.conteudo.length > 0)
          ? colaborador.conteudo[0]
          : colaborador;

      const colab = colaboradorReal || {}
      const colabCargo = colab.cargo || {}
      const colabEmail = colab.email || {}

      if (this.nomeAcao === 'ADICIONAR') {
        this.clean()
        this.cloneColaborador = { id: null, nome: '', email: { endereco: '' }, cargo: { nome: '', id: null } }
      } else {
        this.cloneColaborador = cloneDeep(colab)

        if (this.cloneColaborador.cargo && this.cloneColaborador.cargo.nome === 'PREENCHER O CARGO') {
          this.cloneColaborador.cargo.nome = ''
        } else if (!this.cloneColaborador.cargo) {
          this.cloneColaborador.cargo = { nome: '', id: null }
        }

        if (!this.cloneColaborador.email) {
          this.cloneColaborador.email = { endereco: '' }
        }

        this.idTipoArea = colabCargo.id || ''
        this.nomeColaborador = colab.nome || ''
        this.emailColaborador = colabEmail.endereco || ''

        const cargoNome = colabCargo.nome || ''
        this.cargoColaborador = cargoNome === 'PREENCHER O CARGO' ? '' : cargoNome

        this.idCargoProp = colabCargo.id || ''
        this.idColaborador = colab.id || null
      }

      this.nomeArea = this.area
      this.emailArea = this.email

      this.loadingComponent = false
    },
    clean() {
      this.idColaborador = ''
      this.nomeColaborador = ''
      this.emailColaborador = ''
      this.cargoColaborador = ''
    },
    async getCargos() {
      const cargos = new Cargo(this.tokenBearer, this.$appConfig.config.API)

      return cargos.getCargos().then((res) => {
        res = res.data

        res.forEach((item) => {
          this.listaCargos.push(item.nome)
          this.dominiosCargos.push(item)
        })
      })
    },
    selectArea(index) {
      this.idTipoArea = index !== null && index > -1 ? this.dominiosAreas[index].id : null

      if (this.nomeAcao === 'EDITAR')
        this.emailArea = index !== null && index > -1 ? this.dominiosAreas[index].emailArea.endereco : ''
    },
    selectCargo(index) {
      this.idCargo = index !== null && index > -1 ? this.dominiosCargos[index].id : null
    },
    async saveChanges(bool) {
      const res = await this.$refs.observer.validate()

      if (
          res ||
          (this.nomeAcaoArea === 'ADICIONAR' && this.nomeColaborador && this.emailColaborador && this.cargoColaborador)
      ) {
        const obj = {
          cargo: {
            id:
                this.nomeAcao === 'EDITAR'
                    ? this.idCargo && this.idCargo > -1
                        ? this.idCargo
                        : this.colaborador.cargo.id
                    : this.idCargo
          },
          email: { endereco: this.emailColaborador },
          id: this.colaborador ? this.colaborador.id : null,
          nome: this.nomeColaborador
        }

        if (bool) this.$emit('save', { obj, idArea: this.idTipoArea })
        else this.$emit('new-save', { obj, idArea: this.idTipoArea })
      }
    }
  },
  computed: {
    boolComputed() {
      return !this.isNew && !this.isEdit
    }
  },
  watch: {
    show() {
      if (!this.show) {
        this.$emit('input', false)
      }
    },
    value() {
      this.show = this.value
    },
    area() {
      this.nomeArea = this.area
    },
    email() {
      this.emailArea = this.email
    }
  }
}
</script>

<style scoped>
.body-line {
  padding-bottom: 15px;
  border-bottom: 1px solid #9e9e9e80;
}
</style>